import { Observable, catchError } from "rxjs";
import { AbstractService } from "../core/AbstractService";
import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { env } from "../../env/env";
import { StructureProgrammatiqueRequest } from "../data/http/requests/structureprogrammatique.req";
import { StructureProgrammatiqueResponse } from "../data/http/responses/structureprogrammatique.res";
import { AppService } from "../core/app.service";
import { ApiResponse } from "../data/http/responses/apiresponse.response";
@Injectable({ // Ajoutez le décorateur Injectable
    providedIn: 'root' // Rend le service disponible dans toute l'application
})
export class StructureProgammatiqueService extends AbstractService<StructureProgrammatiqueRequest, StructureProgrammatiqueResponse> {
    constructor(http: HttpClient, appService: AppService) {
        super(`${env.apiUrl}intervention`, http, null, appService);
    }

    getChildren(appId: string, nodeId: string, page: number = 0, size: number = 100): Observable<ApiResponse<StructureProgrammatiqueResponse[]>> {
        return this.http.get<ApiResponse<StructureProgrammatiqueResponse[]>>(
            `${env.apiUrl}intervention/${appId}/children/${nodeId}?page=${page}&size=${size}`,
            { headers: this.getHeaders() }
        ).pipe(
            catchError(this.handleError)
        );
    }

    getAllByType(appId: string, type: string): Observable<ApiResponse<StructureProgrammatiqueResponse[]>> {
        return this.http.get<ApiResponse<StructureProgrammatiqueResponse[]>>(
            `${env.apiUrl}intervention/by-app-id-and-type/${appId}/${type}`,
            { headers: this.getHeaders() }
        ).pipe(
            catchError(this.handleError)
        );
    }

    getLightById(appId: string, id: string): Observable<ApiResponse<any>> {
        return this.http.get<ApiResponse<any>>(
            `${env.apiUrl}intervention/light/${appId}/${id}`,
            { headers: this.getHeaders() }
        ).pipe(
            catchError(this.handleError)
        );
    }

    getAllDescendants(appId: string, nodeId: string): Observable<ApiResponse<any>> {
        return this.http.get<ApiResponse<any>>(
            `${env.apiUrl}intervention/descendants/${appId}/${nodeId}`,
            { headers: this.getHeaders() }
        ).pipe(catchError(this.handleError));
    }

}
